import { render, staticRenderFns } from "./OldToNew.vue?vue&type=template&id=4342990a&scoped=true&"
import script from "./OldToNew.vue?vue&type=script&lang=js&"
export * from "./OldToNew.vue?vue&type=script&lang=js&"
import style0 from "./OldToNew.vue?vue&type=style&index=0&id=4342990a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4342990a",
  null
  
)

export default component.exports